import { LinkInputRow } from '../UI/LinkInputRow/LinkInputRow';
import { RunTestBulkFilterSelect, runTestBulkOptions, RunTestBulkPageTypeSelect } from './RunTestBulkSelects';
import { useEffect } from 'react';
import DeleteIcon from '../../assets/images/delete.svg?react';
import { PageType, Test } from './RunTest';
import { FormikHelpers, FormikState } from 'formik';
import { RunTestBulkInitialValues } from './RunTestBulk';
import { RunTestSingleInitialValues } from './RunTestSingle';
import { useAuth } from '../../hooks/useAuth';

interface RunTestRowProps {
  test: Test;
  index: number;
  values: FormikState<RunTestBulkInitialValues>['values'] | FormikState<RunTestSingleInitialValues>['values'];
  setValues:
    | FormikHelpers<RunTestBulkInitialValues>['setValues']
    | FormikHelpers<RunTestSingleInitialValues>['setValues'];
  handleChange: (e: any) => void;
  handleDelete: (values: any, setValues: any, index: number) => void;
  minOneTest?: boolean;
  pageTypes?: PageType[];
}

const RunTestRow = ({
  test,
  index,
  values,
  setValues,
  handleChange,
  handleDelete,
  minOneTest = false,
  pageTypes = []
}: RunTestRowProps) => {
  const { group } = useAuth();
  const WPC_PL_GROUP_ID = import.meta.env.VITE_WPC_PL_GROUP_ID;

  const pageTypeValue = (pageType: string) => {
    return pageTypes?.find((option) => option.value === pageType);
  };

  const filterOptions = (pageType: string) => {
    return runTestBulkOptions.filter((option) => {
      if (pageType === '') {
        return true;
      } else if (
        pageType === 'brokenlink' ||
        pageType === 'Common' ||
        pageType === 'pre-qa' ||
        pageType === 'pd-pre-qa'
      ) {
        const allowedValues = ['content', 'gnb', 'footer'];
        return allowedValues.includes(option.value);
      } else {
        const allowedValues = ['otk', 'checklist'];
        return allowedValues.includes(option.value);
      }
    });
  };

  const filterValue = (label: string) => {
    return runTestBulkOptions.filter((option) => {
      if (label === '') {
        return false;
      } else {
        return label.split('&').includes(option.value);
      }
    });
  };

  useEffect(() => {
    const isWpcPlGroup = group && group.id === WPC_PL_GROUP_ID;

    const linkPageType = pageTypes?.find((pageType) =>
      isWpcPlGroup ? pageType.value === 'pre-qa' : pageType.value === 'brokenlink'
    );
    if (linkPageType) {
      handleChange({
        target: {
          name: `tests[${index}].pageType`,
          value: linkPageType.value
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageTypes, group, WPC_PL_GROUP_ID]);

  return (
    <div className={'run-test-link-full-row-container'}>
      <div className="run-test-link-wrap">
        <LinkInputRow handleChange={handleChange} name={`tests[${index}].name`} />
      </div>
      <div className={'run-test-page-type-select-column'}>
        <div className={'run-test-page-type-select'}>
          <RunTestBulkPageTypeSelect
            onChange={(e: { value: any }) => {
              handleChange({
                target: {
                  name: `tests[${index}].pageType`,
                  value: e.value
                }
              });

              handleChange({
                target: {
                  name: `tests[${index}].label`,
                  value: ''
                }
              });
            }}
            options={pageTypes}
            name={`tests[${index}].pageType`}
            value={pageTypeValue(test.pageType)}
            defaultValue={pageTypes[0]}
          />
        </div>
        <div>
          <RunTestBulkFilterSelect
            options={filterOptions(test.pageType)}
            onChange={(e: { value: any }[]) => {
              handleChange({
                target: {
                  name: `tests[${index}].label`,
                  value: e ? e.map((option) => option.value).join('&') : ''
                }
              });
            }}
            isDisabled={test.pageType === ''}
            name={`tests[${index}].label`}
            value={filterValue(test.label)}
          />
        </div>
        <button
          className="run-test-delete-btn"
          onClick={() => (minOneTest && values.tests.length === 1 ? null : handleDelete(values, setValues, index))}
          disabled={minOneTest && values.tests.length === 1}
          type="button"
        >
          <DeleteIcon fill={'#808080'} />
        </button>
      </div>
    </div>
  );
};

export default RunTestRow;
